const evaluateMapMessage = ({ args }) => {
  const stepIds = args?.inputStepIds || [];

  if (stepIds.length < 1) {
    return 'Map data sources';
  }

  return `Map ${stepIds.length} data source${stepIds.length === 1 ? '' : 's'}`;
};

export default evaluateMapMessage;
